import React, { useContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

// #region Components
import Input from "shared/components/FormElements/Input";
import Button from "shared/components/FormElements/Button";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import ErrorModal from "shared/components/UIElements/ErrorModal";
// #endregion Components

// #region Utils
import { VALIDATOR_REQUIRE, VALIDATOR_NONE } from "shared/util/validators";
// #endregion Utils

// #region Hooks
import { useForm } from "shared/hooks/form-hook";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
// #endregion Hooks

import "./Item.css";

const TransferRegionNew = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);
  const [openError, setOpenError] = useState(false);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const updateStoreItems = store.UpdateIkarusTransferRegions;
  const ItemTypeTR = "Transfer Bölgesi";
  const APIEndPoint = "ikarustransferregions";

  const itemSubmitHandler = async (event) => {
    event.preventDefault();

    let amounttoWrite = 0;
    let amounttoWrite_VIP = 0;
    let amounttoWrite_5_10 = 0;
    //check if amount is number
    if (
      isNaN(formState.inputs.amount.value) ||
      isNaN(formState.inputs.amount_VIP.value) ||
      isNaN(formState.inputs.amount_5_10.value)
    ) {
      setOpenError(true);
      return;
    } else {
      amounttoWrite = parseInt(formState.inputs.amount.value);
      amounttoWrite_VIP = parseInt(formState.inputs.amount_VIP.value);
      amounttoWrite_5_10 = parseInt(formState.inputs.amount_5_10.value);
    }

    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/${APIEndPoint}`,
        "POST",
        JSON.stringify({
          name: formState.inputs.name.value,
          name_EN: formState.inputs.name_EN.value,
          name_RU: formState.inputs.name_RU.value,
          amount: amounttoWrite,
          amount_VIP: amounttoWrite_VIP,
          amount_5_10: amounttoWrite_5_10,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );

      updateStoreItems();
      // history.replace(`/transfermanagement`);
      //history.push(`/${ItemEndPointType}`);
    } catch (err) {}
  };

  const [formState, inputHandler] = useForm(
    {
      name: { value: "", isValid: false },
      name_EN: { value: "", isValid: false },
      name_RU: { value: "", isValid: false },
      amount: { value: "", isValid: false },
      amount_VIP: { value: "", isValid: false },
      amount_5_10: { value: "", isValid: false },
    },
    false
  );

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenError(false);
  };

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />

      <Snackbar
        open={openError}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          Ücret bilgileri sayısal bir değer olmalıdır!
        </MuiAlert>
      </Snackbar>

      <form className="new-item-form" onSubmit={itemSubmitHandler}>
        {isLoading && <LoadingSpinner asOverlay />}
        <h3>{ItemTypeTR} Ekle</h3>
        <Input
          id="name"
          element="input"
          type="text"
          label="İsim"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="İsim giriniz."
          onInput={inputHandler}
        />
        <Input
          id="name_EN"
          element="input"
          type="text"
          label="İsim (İngilizce)"
          validators={[VALIDATOR_NONE()]}
          errorText="İsim giriniz."
          onInput={inputHandler}
        />
        <Input
          id="name_RU"
          element="input"
          type="text"
          label="İsim (Rusça)"
          validators={[VALIDATOR_NONE()]}
          errorText="İsim giriniz."
          onInput={inputHandler}
        />

        <Input
          id="amount"
          element="input"
          type="text"
          label="Ücret (1-5 kişi)"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="Ücret giriniz."
          onInput={inputHandler}
        />

        <Input
          id="amount_5_10"
          element="input"
          type="text"
          label="Ücret (5-10 kişi)"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="Ücret giriniz."
          onInput={inputHandler}
        />
        <Input
          id="amount_VIP"
          element="input"
          type="text"
          label="Ücret (1-5 kişi, VIP)"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="Ücret giriniz."
          onInput={inputHandler}
        />
        <Button type="submit" disabled={!formState.isValid}>
          Yeni {ItemTypeTR} Yarat
        </Button>
      </form>
    </React.Fragment>
  );
};

export default TransferRegionNew;
